import { Component, Input } from '@angular/core'
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { MediaFileTemplate, MediaRoot } from 'elements-sdk'
import { APIService } from 'api/module'
import { MediaCreateFromTemplateCreateModalComponent } from './mediaCreateFromTemplateCreateModal.component'
import { NotifyService } from 'common/util/services/notify.service'

@Component({
  selector: 'media-create-from-template-select-modal',
  templateUrl: './mediaCreateFromTemplateSelectModal.component.pug',
})
export class MediaCreateFromTemplateSelectModalComponent {
  @Input() root: MediaRoot
  templates?: MediaFileTemplate[]

  constructor (
    private ngbModal: NgbModal,
    private modalInstance: NgbActiveModal,
    private api: APIService,
    private notify: NotifyService,
  ) {
    api.mediaLibrary.getAllMediaFileTemplates({ ordering: 'name' }).then(templates => {
      this.templates = templates
    })
  }

  async selectTemplate (template: MediaFileTemplate) {
    const modal = this.ngbModal.open(MediaCreateFromTemplateCreateModalComponent)
    modal.componentInstance.root = this.root
    modal.componentInstance.fileTemplate = template
    const { name, customFields } = await modal.result.catch(() => ({}))
    if (!name) {
      return
    }
    this.modalInstance.close({ template, name, customFields })
  }

  async deleteTemplate (template: MediaFileTemplate) {
    this.templates = this.templates!.filter(t => t.id !== template.id)
    try {
      await this.api.mediaLibrary.deleteMediaFileTemplate(template)
    } catch (e) {
      this.notify.errorFromResponse('', e)
    }
  }

  close () {
    this.modalInstance.dismiss()
  }
}
